var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 144 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2948_12925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9799 52.6888C45.4559 52.6888 44.0223 52.0953 42.9452 51.0183L34.6901 42.7631C33.613 41.6861 33.0195 40.2524 33.0195 38.7284V25.5202C33.0195 22.3745 35.5791 19.8125 38.7273 19.8125C41.8755 19.8125 44.435 22.3721 44.435 25.5202V36.3642L51.0196 42.9463C53.2445 45.1713 53.2445 48.7908 51.0196 51.0183C49.9425 52.0953 48.5088 52.6888 46.9848 52.6888H46.9799Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7468 102.216C68.6011 102.216 66.0391 99.6567 66.0391 96.5085C66.0391 93.3604 68.5986 90.8008 71.7468 90.8008H104.767C107.913 90.8008 110.475 93.3604 110.475 96.5085C110.475 99.6567 107.915 102.216 104.767 102.216H71.7468Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7468 126.982C68.6011 126.982 66.0391 124.422 66.0391 121.274C66.0391 118.126 68.5986 115.566 71.7468 115.566H82.752C85.8977 115.566 88.4597 118.126 88.4597 121.274C88.4597 124.422 85.9002 126.982 82.752 126.982H71.7468Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2359 160C42.9851 160 33.0204 150.033 33.0204 137.785V77.0924L30.9786 76.6772C22.3572 74.926 14.5026 70.205 8.8608 63.3811C3.14573 56.4669 0 47.7111 0 38.7257C0 17.3723 17.3723 0 38.7257 0C44.9219 0 50.8421 1.419 56.3179 4.21548C61.5445 6.88495 66.1751 10.7854 69.7116 15.4918L70.4761 16.5102H121.274C133.525 16.5102 143.49 26.4774 143.49 38.7257V137.785C143.49 150.035 133.523 160 121.274 160H55.2359ZM76.6772 30.9786C77.1901 33.5089 77.4514 36.1173 77.4514 38.7257C77.4514 47.7111 74.3057 56.4669 68.5906 63.3811C62.9513 70.205 55.0967 74.9285 46.4728 76.6772L44.431 77.0924V137.785C44.431 143.741 49.2766 148.587 55.2335 148.587H121.272C127.229 148.587 132.074 143.741 132.074 137.785V38.7257C132.074 32.7688 127.229 27.9233 121.272 27.9233H76.0544L76.6747 30.9786H76.6772ZM38.7257 11.413C23.6663 11.413 11.413 23.6663 11.413 38.7257C11.413 53.7852 23.6663 66.0384 38.7257 66.0384C53.7852 66.0384 66.0384 53.7852 66.0384 38.7257C66.0384 23.6663 53.7852 11.413 38.7257 11.413Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2948_12925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.492,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.4496fe8c.svg";
export { ForwardRef as ReactComponent };